import WebFont from 'webfontloader';

export default () => {
  WebFont.load({
    google: {
      families: [ 'Playfair+Display:400,400i,700,700i', 'Source+Sans+Pro:400,400i,700' ]
    }
  });
}
